import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/commerce-php/commerce-php/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "coding-faq"
    }}>{`Coding FAQ`}</h1>
    <p>{`This page is a compilation of frequently asked coding questions by the Magento Open Source Community.`}</p>
    <h2 {...{
      "id": "what-do-i-need-to-know-to-work-with-the-framework"
    }}>{`What do I need to know to work with the framework?`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://en.wikipedia.org/wiki/SOLID_(object-oriented_design)"
        }}>{`SOLID principles`}</a>{` - The essential principles needed to create maintainable and extendable code.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.php.net/"
        }}>{`PHP`}</a>{` - This is the programming language used for developing application code.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://en.wikipedia.org/wiki/HTML"
        }}>{`HTML`}</a>{`, `}<a parentName="li" {...{
          "href": "https://en.wikipedia.org/wiki/Cascading_Style_Sheets"
        }}>{`CSS`}</a>{`, and `}<a parentName="li" {...{
          "href": "https://www.javascript.com/"
        }}>{`JavaScript`}</a>{` - Languages used for `}<a parentName="li" {...{
          "href": "https://developer.adobe.com/commerce/frontend-core/guide/"
        }}>{`frontend development`}</a>{`.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../../architecture/basics/index.md"
        }}>{`Architecture basics overview`}</a>{` - Developers should be familiar with the architectural concepts, such as the `}<a parentName="li" {...{
          "href": "https://en.wikipedia.org/wiki/Model%E2%80%93view%E2%80%93controller"
        }}>{`Model-View-Controller`}</a>{` pattern and the `}<a parentName="li" {...{
          "href": "http://martinfowler.com/bliki/CQRS.html"
        }}>{`Command Query Responsibility Segregation`}</a>{` principle.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../../development/components/dependency-injection.md"
        }}>{`Dependency Injection`}</a>{` - An important design pattern used to handle dependencies across classes and modules.`}</li>
    </ul>
    <h2 {...{
      "id": "how-can-my-extension-distinguish-between-the-magento-open-source-and-the-adobe-commerce"
    }}>{`How can my extension distinguish between the Magento Open Source and the Adobe Commerce?`}</h2>
    <p>{`The correct edition can be obtained through `}<inlineCode parentName="p">{`\\Magento\\Framework\\App\\ProductMetadataInterface::getEdition`}</inlineCode>{`.`}</p>
    <p>{`In Magento Open Source that interface maps to the concrete implementation `}<inlineCode parentName="p">{`Magento\\Framework\\AppInterface\\ProductMetadata`}</inlineCode>{`.
However, in Adobe Commerce, the Commerce module will override that mapping and the interface will be implemented by `}<inlineCode parentName="p">{`\\Magento\\Enterprise\\Model\\ProductMetadata`}</inlineCode>{`.`}</p>
    <p>{`Just relying on the interface through dependency injection will get you the right class, and calling "getEdition" will return the right answer.`}</p>
    <h2 {...{
      "id": "how-do-i-configure-my-module-so-that-it-appears-in-a-specific-place-on-the-admin"
    }}>{`How do I configure my module so that it appears in a specific place on the Admin?`}</h2>
    <p>{`Use the `}<inlineCode parentName="p">{`<Module Directory>/etc/adminhtml/menu.xml`}</inlineCode>{` file to configure from where on the Admin your extension is accessible.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      